import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import API from '../services/api';

const BannerSlider = () => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBanners();
    }, []);

    const fetchBanners = async () => {
        try {
            const res = await API.get('/banners');
            setBanners(res.data);
        } catch (err) {
            console.error("Error fetching banners:", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return (
        <div className="w-full h-32 bg-gray-200 animate-pulse rounded-2xl mb-4"></div>
    );

    if (banners.length === 0) return null;

    return (
        <div className="w-full mb-6">
            <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={10}
                slidesPerView={1}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                className="rounded-2xl overflow-hidden shadow-lg border border-theme-border"
                style={{ height: '140px' }}
            >
                {banners.map((banner) => (
                    <SwiperSlide key={banner.id}>
                        <a href={banner.link_url} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
                            <img 
                                src={banner.image_url} 
                                alt="Ad Banner" 
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                    e.target.src = 'https://via.placeholder.com/800x400?text=WinroX11+Special+Offer';
                                }}
                            />
                        </a>
                    </SwiperSlide>
                ))}
            </Swiper>
            
            <style dangerouslySetInnerHTML={{ __html: `
                .swiper-pagination-bullet {
                    background: var(--text-primary);
                    opacity: 0.3;
                }
                .swiper-pagination-bullet-active {
                    background: var(--accent-primary) !important;
                    opacity: 1;
                    width: 20px;
                    border-radius: 4px;
                }
            `}} />
        </div>
    );
};

export default BannerSlider;
